import { ReactNode } from 'react';

export function MatcherStandardStepTitle({
  children,
  noSubtitle = false
}: Readonly<{ children: ReactNode; noSubtitle?: boolean }>) {
  return (
    <p
      className={`text-6 font-semibold ${noSubtitle ? 'mb-4' : 'mb-0.5'}`}
      data-testid="matcher_standard_step_title"
    >
      {children}
    </p>
  );
}
